(function ($, Drupal) {
    Drupal.behaviors.selectOptionFilter = {
      attach: function (context, settings) {
        const selects = $('.extra-benefits', context);
  
        selects.once('selectOptionFilter').each(function () {

          $(this).on('change', function () {
            const selectedValues = selects.map(function () {
              return $(this).val();
            }).get();
            console.log("Selected values:", selectedValues);
  
            selects.each(function () {
              const currentSelect = $(this);
              const currentValue = currentSelect.val();
              
              $('option', this).each(function () {
                const optionValue = $(this).attr('value');
                if (selectedValues.includes(optionValue) && currentValue !== optionValue) {
                  $(this).attr('disabled', true);
                  $(this).css('display', 'none');
                } else {
                  $(this).attr('disabled', false);
                  $(this).css('display', 'inline');
                }
              });
            });
          });
        });
      }
    };
  })(jQuery, Drupal);